import { useState, useEffect } from 'react';
import { apiService } from '../services/apiService';

export const useContributionTypes = () => {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTypes = async () => {
      setLoading(true);
      setError(null);
      
      try {
        console.log('Fetching contribution types...');
        const response = await apiService.makeRequest('/contributions/types/list');
        console.log('Contribution types response:', response);
        
        // L'API retourne directement un tableau
        const typesData = Array.isArray(response) ? response : [];
        
        console.log('Parsed types:', typesData);
        setTypes(typesData);
      } catch (err) {
        console.error('Error loading types:', err);
        setError(err.message);
        setTypes([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTypes();
  }, []);

  return { types, loading, error };
};